import { createReducer } from 'lib/utilities.js';
import mergeByProp from '../../../lib/mergeByProp.js';
import mapToCamelCase from '../../../lib/mapToCamelCase.js';
import formatPlatformRegistrations from 'screens/settings/redux/lib/formatPlatformRegistrations.js';

const initialState = {
  platformRegistrations: [],
  utmSources: [],
  utmCampaigns: [],
  emailSignatures: [],
  automatedReports: [],
  servicePersons: [],
  servicePersonLocations: [],
  apiKeys: [],
};

export default createReducer(initialState, {
  GET_PLATFORM_REGISTRATION_SUCCESS: (state, payload) => ({
    ...state,
    platformRegistrations: formatPlatformRegistrations([...state.platformRegistrations.filter((n) => n.id !== payload.data.id), payload.data]),
  }),

  GET_PLATFORM_REGISTRATIONS_SUCCESS: (state, payload) => ({
    ...state,
    platformRegistrations: formatPlatformRegistrations([...payload.data]),
  }),

  DELETE_PLATFORM_REGISTRATION_SUCCESS: (state, payload) => ({
    ...state,
    platformRegistrations: formatPlatformRegistrations(
      mergeByProp('id', state.platformRegistrations, payload.data.platform_registrations, (old, nw) => ({
        ...old,
        deleted: nw.deleted,
      }))
    ),
  }),

  GET_CUSTOM_UTM_SOURCES_SUCCESS: (state, payload) => ({
    ...state,
    utmSources: [...payload.data.custom],
  }),

  GET_CUSTOM_UTM_CAMPAIGNS_SUCCESS: (state, payload) => ({
    ...state,
    utmCampaigns: [...payload.data.custom],
  }),

  GET_EMAIL_SIGNATURES_SUCCESS: (state, payload) => ({
    ...state,
    emailSignatures: [...payload.data].map(mapToCamelCase),
  }),

  GET_AUTOMATED_REPORTS_SUCCESS: (state, payload) => ({
    ...state,
    automatedReports: [...payload.data].map(mapToCamelCase),
  }),

  GET_SERVICE_PERSONS_SUCCESS: (state, payload) => ({
    ...state,
    servicePersons: [...payload.data].map(mapToCamelCase),
  }),

  PUT_SERVICE_PERSON_SUCCESS: (state, payload) => ({
    ...state,
    servicePersons: mergeByProp('id', state.servicePersons, [payload.data].map(mapToCamelCase)),
  }),

  GET_SERVICE_PERSON_LOCATIONS_SUCCESS: (state, payload) => ({
    ...state,
    servicePersonLocations: [...payload.data].map(mapToCamelCase),
  }),

  DELETE_SERVICE_PERSON_LOCATION_SUCCESS: (state, payload) => ({
    ...state,
    servicePersonLocations: (state.servicePersonLocations || []).filter((n) => n.id !== payload.data.id),
  }),

  PUT_SERVICE_PERSON_LOCATION_SUCCESS: (state, payload) => ({
    ...state,
    servicePersonLocations: mergeByProp('id', state.servicePersonLocations, [payload.data].map(mapToCamelCase)),
  }),

  GET_API_KEYS_SUCCESS: (state, payload) => ({
    ...state,
    apiKeys: [...payload.data].map(mapToCamelCase),
  }),
});
